import { StyledText } from 'src/components/StyledTypography';
import { LineDetails } from 'src/views/vendorprogram/hooks/deal-details';
import AdditionalAttributeTable from '../../AdditionalAttributeTable/AdditionalAttributeTable';
import React from 'react';
import OrderHistoryTableDrawer from '../../OrderHistoryDrawer/OrderHistoryTableDrawer';
import ImSkuTable from '../../IMSKUTable/ImSkuTable';
import VpnListPage from '../../VPNList/VpnListPage';
import EditImSKUDrawer from 'src/views/vendorprogram/ExceptionDeals/EDDetailsPageEditLine';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

export type OpenPopupType =
  | 'orderHistory'
  | 'vpnList'
  | 'imSkuTable'
  | 'additionalAttribute'
  | 'imSku';

type Props = {
  cellValue?: string | number;
  openPopup: {
    lineDetails: LineDetails;
    type: OpenPopupType;
  } | null;
  row: LineDetails;
  setOpenPopup: React.Dispatch<
    React.SetStateAction<{
      lineDetails: LineDetails;
      type: OpenPopupType;
    } | null>
  >;
};

export const ProductBusinessTypeCol = (props: Props) => {
  return (
    <>
      <StyledText
        onClick={(e) => {
          e.stopPropagation();
          props.setOpenPopup({
            lineDetails: props.row,
            type: 'additionalAttribute',
          });
        }}
        sx={{ wordBreak: 'break-word' }}
        variant="link"
      >
        {props.row.product_business_type}
      </StyledText>
      {props.openPopup?.type === 'additionalAttribute' &&
        props.row.dd_tracking === props.openPopup?.lineDetails.dd_tracking && (
          <AdditionalAttributeTable
            handleClose={() => props.setOpenPopup(null)}
            item={props.row}
          />
        )}
    </>
  );
};

export const OrderHistoryCol = (
  props: Props & { importreferenceid: number }
) => {
  return (
    <>
      <StyledText
        onClick={(e) => {
          e.stopPropagation();
          props.setOpenPopup({ lineDetails: props.row, type: 'orderHistory' });
        }}
        variant="link"
      >
        {props.cellValue}
      </StyledText>
      {props.openPopup?.type === 'orderHistory' &&
        props.row.dd_tracking === props.openPopup?.lineDetails.dd_tracking && (
          <OrderHistoryTableDrawer
            handleClose={() => props.setOpenPopup(null)}
            importreferenceid={props.importreferenceid}
            lineDetails={props.openPopup.lineDetails}
          />
        )}
    </>
  );
};

export const ImSkuTableCol = (
  props: Props & {
    isXcmVendor: boolean;
    vendorProgramId: number;
  }
) => {
  return (
    <>
      <StyledText
        onClick={(e) => {
          e.stopPropagation();
          props.setOpenPopup({ lineDetails: props.row, type: 'imSkuTable' });
        }}
        sx={{ wordBreak: 'break-word' }}
        variant="link"
      >
        {props.cellValue}
      </StyledText>
      {props.openPopup?.type === 'imSkuTable' &&
        props.row.dd_tracking === props.openPopup?.lineDetails.dd_tracking && (
          <ImSkuTable
            handleClose={() => props.setOpenPopup(null)}
            isXcmVendor={props.isXcmVendor}
            item={props.openPopup.lineDetails}
            vendorProgramId={String(props.vendorProgramId)}
          />
        )}
    </>
  );
};

export const VpnHistoryCol = (props: Props & { importreferenceid: number }) => {
  const getCellText = (value: any) => {
    if (value === null) {
      return 'None';
    }
    if (value === 'True') {
      return 'Exc';
    }
    return 'Inc';
  };
  return (
    <>
      {props.row.vendor_number !== null ? (
        <StyledText
          onClick={(e) => {
            e.stopPropagation();
            props.row.vendor_number
              ? props.setOpenPopup({ lineDetails: props.row, type: 'vpnList' })
              : props.setOpenPopup(null);
          }}
          variant="link"
        >
          {getCellText(props.cellValue)}
        </StyledText>
      ) : (
        <StyledText></StyledText>
      )}

      {props.openPopup?.type === 'vpnList' &&
        props.row.dd_tracking === props.openPopup?.lineDetails.dd_tracking && (
          <VpnListPage
            handleClose={() => props.setOpenPopup(null)}
            importreferenceid={props.importreferenceid}
            lineDetails={props.openPopup.lineDetails}
          />
        )}
    </>
  );
};

export const ImSkuCol = (
  props: Props & {
    enableRulesEngine: boolean;
    isXcmVendor: boolean;
    productLocalizationForWeb: string;
    vendorProgramId: number;
    version: number;
  }
) => {
  return (
    <Stack flexDirection="row" gap={0.5} justifyContent="space-between">
      <span>{props.cellValue}</span>
      {props.row.vpn && props.row.productset_type !== 'BL' && (
        <IconButton
          data-testid={`gds-vp-sku-edit-icon`}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            props.setOpenPopup({ lineDetails: props.row, type: 'imSku' });
          }}
          size="small"
        >
          <EditIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
      {props.openPopup?.type === 'imSku' &&
        props.row.dd_tracking === props.openPopup?.lineDetails.dd_tracking && (
          <EditImSKUDrawer
            dealnumber={props.row.deal_number ?? ''}
            dealversion={props.version}
            enableRulesEngine={props.enableRulesEngine}
            handleClose={() => props.setOpenPopup(null)}
            isXcmVendor={props.isXcmVendor}
            productLocalizationForWeb={props.productLocalizationForWeb}
            rowData={props.row}
            vendorProgramId={props.vendorProgramId}
          />
        )}
    </Stack>
  );
};
